import { ACCOUNT_TYPE } from 'modules/auth/constants';

export const ACCOUNT_ROLE_ON_URL = {
  [ACCOUNT_TYPE.AGENCY]: 'agency',
  [ACCOUNT_TYPE.CAMPAIGN]: 'campaign',
  [ACCOUNT_TYPE.ORGANIZATION]: 'org',
};
